module.exports = __webpack_public_path__ + "img/covers-02.8d06b3b4.png";